"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTRACT_TYPE = exports.INSTITUTE_NAME = exports.NOT_YET_APPROVED = exports.APPROVED = exports.TOTAL = exports.STUDENT_NAME = exports.STUDENT_ID = exports.GRADE = exports.TOTAL_SCORE = exports.SCORE_FINAL = exports.SCORE_MIDTERM = exports.SCORE_ATTENDANCE = exports.API_DASHBOARD = exports.API_TRANSCRIPT = exports.API_ANNUAL = exports.API_ANNUAL_SCORE = exports.API_SESSION_SCORE = exports.API_STUDENT_SCORE = exports.API_SUBJECT = exports.API_SESSION = exports.API_ACADEMIC_YEAR = exports.API_MAJOR_GENERATION = exports.API_USER = exports.API_MAJOR = exports.API_STUDENT = exports.API_LECTURER = exports.API_PERMISSION = exports.API_LOGIN_EXCHANGE = exports.API_LOGIN = exports.API_ROLE = exports.ACTIVE_FIELD = exports.VALUE_FIELD = exports.ORDERING_FIELD = exports.ACCESS_ROLE_FIELD = exports.ID_FIELD = exports.ACADEMIC_YEARS_TABLE = exports.ACCESS_ROLE_PERMISSION_TABLE = exports.PERMISSION_TABLE = exports.ACCESS_ROLE_TABLE = exports.USER_TABLE = exports.ROLE_LECTURER = exports.ROLE_STUDENT = exports.ROLE_TOP_MANAGER = exports.ROLE_ECOM_ADMIN = exports.ROLE_CS_ADMIN = exports.ROLE_FOUNDATION_ADMIN = exports.ROLE_MAJOR_ADMIN = exports.ROLE_TSC_ADMIN = exports.ROLE_SUPER_ADMIN = exports.API_PATH = void 0;
exports.IMPORT_SCORE = exports.EXTERNAL_LECTURE_TEMPLATE_CSV_FROM_FIREBASE = exports.INTERNAL_LECTURE_TEMPLATE_CSV_FROM_FIREBASE = exports.STUDENT_TEMPLATE_CSV_FROM_FIREBASE = exports.ACTIVE = exports.GENDER = exports.TITLE = void 0;
// APIS
exports.API_PATH = "/api/v01";
// ROLE VALUES
exports.ROLE_SUPER_ADMIN = "super_admin";
exports.ROLE_TSC_ADMIN = "tsc";
exports.ROLE_MAJOR_ADMIN = "major_admin";
exports.ROLE_FOUNDATION_ADMIN = "major_admin_foundation";
exports.ROLE_CS_ADMIN = "major_admin_cs";
exports.ROLE_ECOM_ADMIN = "major_admin_ecom";
exports.ROLE_TOP_MANAGER = "top_manager";
exports.ROLE_STUDENT = "student";
exports.ROLE_LECTURER = "lecturer";
// TABLES
exports.USER_TABLE = "users";
exports.ACCESS_ROLE_TABLE = "access_roles";
exports.PERMISSION_TABLE = "permissions";
exports.ACCESS_ROLE_PERMISSION_TABLE = "access_roles_permissions";
exports.ACADEMIC_YEARS_TABLE = "academic_years";
// FIELDS
exports.ID_FIELD = "id";
exports.ACCESS_ROLE_FIELD = "access_role";
exports.ORDERING_FIELD = "ordering";
exports.VALUE_FIELD = "value";
exports.ACTIVE_FIELD = "active";
// API URL
exports.API_ROLE = `${exports.API_PATH}/access_roles/`;
exports.API_LOGIN = `${exports.API_PATH}/login`;
exports.API_LOGIN_EXCHANGE = `${exports.API_PATH}/exchange`;
exports.API_PERMISSION = `${exports.API_PATH}/permissions/`;
exports.API_LECTURER = `${exports.API_PATH}/lecturers/`;
exports.API_STUDENT = `${exports.API_PATH}/students/`;
exports.API_MAJOR = `${exports.API_PATH}/majors/`;
exports.API_USER = `${exports.API_PATH}/users/`;
exports.API_MAJOR_GENERATION = `${exports.API_PATH}/major_generations/`;
exports.API_ACADEMIC_YEAR = `${exports.API_PATH}/academic_years/`;
exports.API_SESSION = `${exports.API_PATH}/sessions/`;
exports.API_SUBJECT = `${exports.API_PATH}/subjects/`;
exports.API_STUDENT_SCORE = `${exports.API_PATH}/student_subject_scores/`;
exports.API_SESSION_SCORE = `${exports.API_PATH}/session_scores/`;
exports.API_ANNUAL_SCORE = `${exports.API_PATH}/annual_scores/`;
exports.API_ANNUAL = `${exports.API_PATH}/annuals/`;
exports.API_TRANSCRIPT = `${exports.API_PATH}/transcripts/`;
exports.API_DASHBOARD = `${exports.API_PATH}/dashboard/`;
// Score Fields
exports.SCORE_ATTENDANCE = "Attendance";
exports.SCORE_MIDTERM = "Midterm";
exports.SCORE_FINAL = "Final";
exports.TOTAL_SCORE = "total_score";
exports.GRADE = "Grade";
exports.STUDENT_ID = "Student ID";
exports.STUDENT_NAME = "Student Name";
exports.TOTAL = "Total Score";
// Approve
exports.APPROVED = "Approve";
exports.NOT_YET_APPROVED = "Not Yet Approve";
exports.INSTITUTE_NAME = "National Institute of Posts, Telecom and ICT";
// Lecturer field
exports.CONTRACT_TYPE = ["Full-Time", "Part-Time"];
exports.TITLE = ["Dr", "Miss", "Mrs", "Mr", "Ms"];
exports.GENDER = ["Male", "Female"];
exports.ACTIVE = ["active", "drop"];
/// Link Storage Firebase
exports.STUDENT_TEMPLATE_CSV_FROM_FIREBASE = "https://firebasestorage.googleapis.com/v0/b/schoolbase.appspot.com/o/documents%2Fimport-student-template.csv?alt=media&token=2a9e9771-7cc4-4439-9755-1d7b9a5915ad";
exports.INTERNAL_LECTURE_TEMPLATE_CSV_FROM_FIREBASE = "https://firebasestorage.googleapis.com/v0/b/schoolbase.appspot.com/o/documents%2Finternal-lecturer-template.csv?alt=media&token=0d1a5dee-05bf-411c-a798-2d241d43d15f";
exports.EXTERNAL_LECTURE_TEMPLATE_CSV_FROM_FIREBASE = "https://firebasestorage.googleapis.com/v0/b/schoolbase.appspot.com/o/documents%2Fexternal-lecture-template.csv?alt=media&token=d4c4a40d-e725-426d-8ca1-43ad298688c6";
exports.IMPORT_SCORE = "https://firebasestorage.googleapis.com/v0/b/schoolbase.appspot.com/o/documents%2Fimport-score-template.csv?alt=media&token=8bc51ef1-b435-4194-aa92-7ffda7b89bd6";
